import React from 'react';
import { Layout,Spin,Space }   from 'antd';
import API from './api/api'
import {useNavigate} from 'react-router-dom'
import efLogo from './assets/logo-c-h.svg';
import { LoadingOutlined } from '@ant-design/icons';
import {Cookies } from 'react-cookie'
const { Sider, Content } = Layout;

//type MenuArray = IMenu[]

function Loading() {
  const navigate = useNavigate()
  //const antIcon = <LoadingOutlined style={{ fontSize: 36 }} spin />

  React.useEffect(() => {
    setTimeout(()=>{
      if(window.localStorage.getItem("token")){
        navigate('/index')
      }else{
        console.log("EFToken not foud, signin")
        navigate('/signin')
      }
    },400)
    
  }, [])
  return (
      <Layout className='bg-zinc-200'>
        <Content  className="h-[100vh] w-[100vw] flex justify-center items-center" >
          <Space>
            <img className="max-w-[160px]" src={efLogo} alt=""></img>
            <Spin size="large" />
          </Space>
          
        </Content>
      </Layout>
  );
}

export default Loading;
